export default obj =>
	Object.keys(obj)
		.map(key => `${key}=${encodeURIComponent(obj[key])}`)
		.join('&');



// WEBPACK FOOTER //
// ./utils/objToHash.js